var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"amygu"}},[_c('div',{staticClass:"lineChart Chart",class:{ratio_class : _vm.useData.id == 'barChart3'},attrs:{"id":_vm.useData.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }